export const clientStatus = {
  ACTIVE: 'active',
  CHECK: 'check',
  BLOCKED: 'blocked'
};

export const clientType = {
  ORGANIZATION: 'organisation',
  INTERMEDIARY: 'intermediary',
  RESELLER: 'reseller',
  OTHER: 'other'
};
